import React from "react";
import styled, { keyframes } from "styled-components";
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from "react-accessible-accordion";

const StyledAccordionItemHeading = styled(AccordionItemHeading)`
  background-color: #303030;
  padding: 10px;
  margin-top: 1px;
  margin-left: 0px;
  color: whitesmoke;
`;

const StyledAccordionItemButton = styled(AccordionItemButton)`
  outline: none;
  &::before {
    display: inline-block;
    content: "";
    height: 5px;
    width: 5px;
    margin-right: 12px;
    border-bottom: 2px solid currentColor;
    border-right: 2px solid currentColor;
    transform: rotate(-45deg);
  }
  &[aria-expanded="true"]::before,
  [aria-selected="true"]::before {
    transform: rotate(45deg);
  }
`;

const fadeIn = keyframes`
  from{
    opacity:0%;
    max-height: 0px;
  }
  to{
    opacity:100%;
    max-height: 600px;
  }
`;

const StyledAccordionItemPanel = styled(AccordionItemPanel)`
  background-color: transparent;
  animation: ${fadeIn} 0.7s ease-in;
`;

export default function Expander({ title, children }) {
  return (
    <AccordionItem>
      <StyledAccordionItemHeading>
        <StyledAccordionItemButton>{title}</StyledAccordionItemButton>
      </StyledAccordionItemHeading>
      <StyledAccordionItemPanel>{children}</StyledAccordionItemPanel>
    </AccordionItem>
  );
}
